/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Hidden 필드 클래스를 정의한다.
 *
 * @file /src/components/form/field/hidden/Hidden.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2025. 6. 19.
 */
import * as parent from '@components/form/field/Field';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T> extends parent.Properties<T> {
    /**
     * 이벤트리스너
     */
    listeners?: Listeners<T>;
}

export class Hidden extends parent.Field {
    /**
     * 컴포넌트 확장타입
     */
    variant = 'hidden';

    /**
     * * Hidden 필드 클래스를 정의한다.
     *
     * @param properties - 초기설정
     */
    constructor(public properties: Properties<Hidden> = null) {
        super(properties);
    }

    /**
     * 컴포넌트를 보이게 설정하더라도, 보이지 않도록 처리한다.
     */
    async show(): Promise<void> {
        return;
    }

    /**
     * 컴포넌트 컨테이너를 렌더링한다.
     */
    async renderDom(): Promise<void> {
        this.$getComponent().hide();
    }
}
